import {useIntl} from 'react-intl'

import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useStore} from '../../hook'
import {useState} from 'react'

const StoreList = ({
  loading,
  isDetail,
  setIsDetail,
}: {
  loading: boolean
  isDetail: {status: boolean; id: string}
  setIsDetail: ({status, id}: {status: boolean; id: string}) => void
}) => {
  const intl = useIntl()
  const {list, listFilter, listFilterSet} = useStore()

  const columns = [
    {key: 'no', dataIndex: 'no', title: intl.formatMessage({id: 'STORE.LOCATION.LIST_ID'})},
    {
      key: 'name',
      dataIndex: 'name',
      title: intl.formatMessage({id: 'STORE.LOCATION.LIST_NAME'}),
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: intl.formatMessage({id: 'STORE.LIST.STATUS'}),
      status: true,
    },
    {
      key: 'cityName',
      dataIndex: 'cityName',
      title: intl.formatMessage({id: 'GLOBAL.CITY'}),
    },
    {
      key: 'action',
      dataIndex: 'id',
      title: intl.formatMessage({id: 'STORE.LIST.ACTION'}),
      render: (id: string) => (
        <button
          className='btn btn-link text-primary'
          onClick={() => setIsDetail({status: true, id})}
        >
          {intl.formatMessage({id: 'STORE.LIST.DETAIL'})}
        </button>
      ),
    },
  ]

  if (isDetail.status) return <></>

  return (
    <>
      <Table
        loading={loading}
        dataSource={list.dataList}
        columns={columns}
        tableName={'stores'}
        pagination={{
          current: listFilter.paging.currentPageNumber,
          pageSize: listFilter.paging.pageSize,
          total: list.paging.totalCount,
          onChange: (page: any) => {
            const {pageSize, current} = page
            const currentPage = pageSize !== listFilter.paging.pageSize ? 1 : current

            listFilterSet({
              ...listFilter,
              paging: {
                ...listFilter.paging,
                pageSize,
                currentPageNumber: currentPage,
              },
            })
          },
        }}
      />
    </>
  )
}

export default StoreList
